// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".info-tile-module__tile__1Z7wn{border-radius:8px;border:1px solid #d3d3d3;padding:1rem;display:inline-block;box-shadow:0px 0.75px 2px 0px rgba(0,22,65,0.1),0px 1.5px 4px 0px rgba(0,22,65,0.1),0px 3px 8px 0px rgba(0,22,65,0.1)}.info-tile-module__category__3iBtS:not(:last-child){border-right:1px solid #d3d3d3;padding-right:1rem}.info-tile-module__category__3iBtS:not(:first-child){padding-left:1rem}\n", ""]);
// Exports
exports.locals = {
	"tile": "info-tile-module__tile__1Z7wn",
	"category": "info-tile-module__category__3iBtS"
};
module.exports = exports;
